import { i18n } from '@shared/i18n';
import IdField from '@shared/fields/id-field';
import DateTimeRangeField from '@shared/fields/date-time-range-field';
import DateTimeField from '@shared/fields/date-time-field';
import { GenericModel } from '@shared/model/generic-model';
import StringField from '@shared/fields/string-field';
import { TeamField } from '@modules/team/team-field';

function label(name) {
  return i18n(`entities.training.fields.${name}`);
}

const fields = {
  id: new IdField('id', label('id')),
  title: new StringField('title', label('title'), {
    "required": true
  }),
  description: new StringField('description', label('description'), {
    "required": true
  }),
  date: new DateTimeField('date', label('date'), {}),
  hour: new StringField('hour', label('hour'), {
    "required": true
  }),
  duration: new StringField('duration', label('duration'), {
    "required": true
  }),
  location: new StringField('location', label('location'), {}),
  status: new StringField('status', label('status'), {}),
  team: TeamField.relationToOne('team', label('team'), {}),
  createdAt: new DateTimeField(
    'createdAt',
    label('createdAt'),
  ),
  updatedAt: new DateTimeField(
    'updatedAt',
    label('updatedAt'),
  ),
  createdAtRange: new DateTimeRangeField(
    'createdAtRange',
    label('createdAtRange'),
  ),
  dateRange: new DateTimeRangeField(
    'dateRange',
    label('dateRange'),
  ),
};

export class TrainingModel extends GenericModel {
  static get fields() {
    return fields;
  }
}
